/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPointComponent, JSResourceReference } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { issueAppEntryPoint } from '@jira/issue__issue-view/src/issueAppEntryPoint.entrypoint.tsx';
import type { AnyEntryPoint } from '@atlassian/entry-point-types/types';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import type { IssuePreviewPanelEntrypointEntrypointProps } from './IssuePreviewPanelEntrypoint.entrypoint.types.tsx';

type IssuePreviewPanelRootComponent = EntryPointComponent<
	{},
	{ issueAppEntryPoint: typeof issueAppEntryPoint },
	IssuePreviewPanelEntrypointEntrypointProps,
	{}
>;

export const issuePreviewPanelEntryPoint: AnyEntryPoint = createEntryPoint<
	JSResourceReference<IssuePreviewPanelRootComponent>,
	EntryPointRouteParams
>({
	root: JSResourceForUserVisible(
		/* webpackChunkName: "async-issue-preview-panel-entrypoint" */ './index.tsx',
		{ entryFsSsrLiftImportToModule: true },
	),
	getPreloadProps: (entryPointParams: EntryPointRouteParams) => {
		return {
			entryPoints: {
				issueAppEntryPoint: {
					entryPoint: issueAppEntryPoint,
					entryPointParams,
				},
			},
		};
	},
});
